import MeaPage from "../../../components/MeaPage";
import { useEffect, useRef, useState } from "react";
import { Checkbox } from "primereact/checkbox";
import trainingsAPI from "../../../services/trainings";
import { Dropdown } from "primereact/dropdown";
import MeaButton from "../../../components/MeaButton";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import tasksAPI from "../../../services/tasks";
import levelsAPI from "../../../services/levels";
import { Panel } from "primereact/panel";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ToFormatedDateWithWeekday, ToFormatedHour } from "../../../utils/dates";
import { useParams } from "react-router-dom";

const ImportCandidatesFromTrainingPage = () => {

    //
    const params = useParams();
    const schoolId = params.schoolId
    const trainingId = params.registrationId;
    const accessToken = "";
    const [loading, setLoading] = useState(false);
    const [hasLogs, setHasLogs] = useState(false);
    const [logsTitle, setLogsTitle] = useState(null);
    const [logs, setLogs] = useState([]);

    const [selectedSourceTraining, setSelectedSourceTraining] = useState(null);
    //
    const trainingQuery = trainingsAPI.useGetList(schoolId, accessToken, 1, 10000);
    const trainings = trainingQuery?.data?.data;
    const filteredTrainings = trainings?.filter(training => training.id !== trainingId);
    //
    const sourceLevelsQuery = levelsAPI.useGetList(schoolId, selectedSourceTraining, accessToken, 1, 100000);
    const sourceLevels = sourceLevelsQuery?.data?.data;
    //
    const targetLevelsQuery = levelsAPI.useGetList(schoolId, trainingId, accessToken, 1, 100000);
    const targetLevels = targetLevelsQuery?.data?.data;
    //
    const levelsMapping = sourceLevels?.map(level => ({
        "sourceLevelId": level.id,
        "sourceLevelName": level.name,
        "targetLevelFailedId": null,
        "targetLevelFailedName": null,
        "targetLevelPassedId": null,
        "targetLevelPassedName": null
    }));
    //
    const resultsRef = useRef(null);

    const [levelMappings, setLevelMappings] = useState([]);
    useEffect(() => {
        setLevelMappings(levelsMapping);
    }, [sourceLevels]);

    const categories = [
        { name: 'En cours', key: 'ONGOING' },
        { name: 'Redoubelement', key: 'FAILED' },
        { name: 'Passage', key: 'PASSED' },
        { name: 'Liste d\'attente', key: 'WAITING_LIST' },
    ];

    const [selectedCategories, setSelectedCategories] = useState([]);

    const onCategoryChange = (e) => {
        let _selectedCategories = [...selectedCategories];
        if (e.checked)
            _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(category => category.key !== e.value.key);
        setSelectedCategories(_selectedCategories);
    };

    const [jobId, setJobId] = useState(null);

    useEffect(() => {
        if (selectedSourceTraining !== null && selectedSourceTraining !== undefined) {
            trainingsAPI.GetTrainingPreferences(schoolId, trainingId, accessToken).then((data) => {
                const mappings = data?.import_trainings_mappings;
                if (mappings) {
                    const decodedMappings = JSON.parse(atob(mappings));
                    const levelMappings = decodedMappings?.find(mapping => mapping.source_training_id === selectedSourceTraining)?.mappings;
                    setLevelMappings(levelMappings);
                };
            });
        }
    }, [selectedSourceTraining]);


    const handleImport = () => {
        setLoading(true);
        setLogsTitle("Importation en élèves...");
        setLogs([]);
        tasksAPI.ImportRegistrationsFromTraining(schoolId, trainingId, accessToken,
            {
                source_training_id: selectedSourceTraining,
                elements: selectedCategories.map(category => category.key),
                mapping: levelMappings
            })
            .then((json) => {
                setJobId(json?.data?.id);
                setHasLogs(true);
            }).catch((error) => {
                console.log(error);
            });
    }

    useEffect(() => {
        const fetchTaskStatus = async () => {
            tasksAPI.GetTask(schoolId, trainingId, jobId, accessToken)
                .then((data) => {
                    setLogsTitle(data?.data?.message);
                    setLogs(data?.data?.job_logs);
                    if (data?.data?.status === "COMPLETED") {
                        {
                            //setSuccessMessage("Fichier importé avec succès!");
                            //setErrorMessage(null);
                            setLoading(false);
                            setJobId(null);
                        }
                    } else if (data?.data?.status === "FAILED") {
                        {
                            //setSuccessMessage();
                            //setErrorMessage(data?.data?.message);
                            setLoading(false);
                            setJobId(null);
                        }
                    }
                    else {
                        setTimeout(fetchTaskStatus, 1000); // Retry after 1 seconds
                    }
                })
                .catch((error) => {
                    console.log("error " + error);
                    //setSuccessMessage(null);
                    //setErrorMessage("Erreur de chargement du fichier!");
                    setJobId(null);
                    setLoading(false);
                });
        };

        if (loading && jobId) {
            fetchTaskStatus();
        }

    }, [loading, jobId]);

    return (
        <>
            <MeaPage title="Importer des élèves" subtitle="Importer des élèves à partir d'une autre formation">
                <ConfirmDialog />
                <div className="flex flex-column mt-3 p-5 bg-white">
                    <div>Séléctionné une anciennce formation et choisir quelles données à importer dans cette nouvelle formation.</div>
                    <div className="mb-4">Les données importés ce seront des copies et n'affecteront en aucun cas la formation source.</div>
                    <div className="text-900 w-full md:w-10 md:flex-order-0 flex-order-1">
                        <ul className="list-none p-0 m-0">
                            <li className="flex align-items-start py-2 px-2 flex-wrap border-bottom-1 surface-border pb-5">
                                <div className="text-500 w-full md:w-3 font-medium">Formation source</div>
                                <div className="text-900 w-full md:w-9">
                                    <Dropdown disabled={hasLogs} value={filteredTrainings?.find(training => training?.id === selectedSourceTraining)}
                                        options={filteredTrainings} optionLabel="name" placeholder="Sélectionner une formation"
                                        onChange={(e) => setSelectedSourceTraining(e.value?.id)} />
                                </div>
                            </li>
                            <li className="flex align-items-start py-2 px-2 flex-wrap border-bottom-1 surface-border pb-5">
                                <div className="text-500 w-full md:w-3 font-medium">Les élèves à importer</div>
                                <div className="text-900 w-full md:w-9">
                                    <div className="flex flex-column gap-3">
                                        {categories.map((category) => {
                                            return (
                                                <div key={category.key} className="flex align-items-center">
                                                    <Checkbox disabled={hasLogs} inputId={category.key} name="category" value={category} onChange={onCategoryChange} checked={selectedCategories.some((item) => item.key === category.key)} />
                                                    <label htmlFor={category.key} className="ml-2">
                                                        {category.name}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </li>
                            <li className="flex align-items-start py-2 px-2 flex-wrap border-bottom-1 surface-border pb-5">
                                <div className="text-500 w-full md:w-3 font-medium">Passage de niveaux</div>
                                <div className="text-900 w-full md:w-9">
                                    <div className="flex flex-column gap-3">
                                        <DataTable size="small" value={levelMappings} editMode="cell">
                                            <Column key="sourceLevelId" field="sourceLevelName" header="Niveau N-1" ></Column>
                                            <Column key="targetLevelFailedId" header="Niveau N (Redoubelement)"
                                                body={(item) => (
                                                    <Dropdown value={targetLevels?.find(level => level.id === item?.targetLevelFailedId) || null}
                                                        options={targetLevels || []}
                                                        optionLabel="name"
                                                        onChange={(e) => {
                                                            const updatedMappings = levelMappings?.map(mapping =>
                                                                mapping?.sourceLevelId === item?.sourceLevelId
                                                                    ? { ...mapping, targetLevelFailedId: e.value?.id, targetLevelFailedName: e.value?.name }
                                                                    : mapping
                                                            );
                                                            setLevelMappings(updatedMappings);
                                                        }}
                                                    />
                                                )}
                                            ></Column>
                                            <Column key="targetLevelPassedId" header="Niveau N (Passage)"
                                                body={(item) => (
                                                    <Dropdown value={targetLevels?.find(level => level.id === item?.targetLevelPassedId) || null}
                                                        options={targetLevels || []} optionLabel="name"
                                                        onChange={(e) => {
                                                            const updatedMappings = levelMappings.map(mapping =>
                                                                mapping.sourceLevelId === item.sourceLevelId
                                                                    ? { ...mapping, targetLevelPassedId: e.value?.id, targetLevelPassedName: e.value?.name }
                                                                    : mapping
                                                            );
                                                            setLevelMappings(updatedMappings);
                                                        }}
                                                    />
                                                )}
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <MeaButton label="Importer" disabled={selectedSourceTraining === null || selectedCategories?.length === 0} loading={loading} className="mt-5" onClick={(e) => {
                                    e.stopPropagation();
                                    const mappings = [
                                        {
                                            source_training_id: selectedSourceTraining,
                                            mappings: levelMappings
                                        }
                                    ]
                                    const encodedMappings = btoa(JSON.stringify(mappings));
                                    trainingsAPI.UpdateTrainingPreferences(schoolId, trainingId, accessToken, { import_trainings_mappings: encodedMappings });
                                    confirmDialog({
                                        message:
                                            "Voulez-vous procéder à l'importation des élèves de la formation sélectionnée ?",
                                        header: "Confirmation",
                                        icon: "pi pi-info-circle",
                                        acceptLabel: "Oui",
                                        rejectLabel: "Non",
                                        defaultFocus: "reject",
                                        reject: () => {
                                            setLoading(false);
                                        },
                                        accept: () => {
                                            handleImport();
                                        },
                                    });
                                }}
                                />
                                {hasLogs && !loading && <MeaButton label="Fermer" outlined className="mt-5 ml-3" onClick={() => window.history.back()} />}
                            </li>
                            {hasLogs && <li className="mt-3">
                                <Panel ref={resultsRef} header={logsTitle} toggleable collapsed>
                                    <DataTable value={logs} size="small">
                                        <Column field="log_type" header="Type" body={(item) =>
                                            <span className={item?.log_type === "WARNING" ? "text-orange-500" : (item?.log_type === "ERRR" ? "text-red-500" : "")}>{item?.log_type}</span>
                                        }></Column>
                                        <Column field="message" header="Message" ></Column>
                                        <Column field="created_at" header="Fait le" body={(item) => <>
                                            {ToFormatedDateWithWeekday(new Date(item?.created_at)) + "  " + ToFormatedHour(new Date(item?.created_at))}
                                        </>}></Column>
                                    </DataTable>

                                </Panel>
                            </li>}
                        </ul>
                    </div>

                </div>
            </MeaPage>
        </>
    );
}
export default ImportCandidatesFromTrainingPage;
